import {ShareDeviceState} from './states/share-device.state';
import {UserDeviceParamsState} from './states/user-device-params.state';
import {DevicesState} from './states/user-devices.state';

export const deviceDashboardStates = [
    DevicesState,
    UserDeviceParamsState,
    ShareDeviceState
];
